const setupIdeaFiltering = () => {
    $('.filter-results input[type=checkbox]').click(e => {
        $(e.target).closest('form').submit();
    });
};

export default setupIdeaFiltering;
